import { Pipe, PipeTransform } from '@angular/core';
import { Filter, GroupSelectFilter } from '@models/filter-types';
import { isGroupSelectFilter } from '@shared/helpers/functions/helpers';

@Pipe({
    name: 'isGroupSelectFilter',
    standalone: false,
})
export class IsGroupSelectFilterPipe implements PipeTransform {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    transform(value: Filter<any>): value is GroupSelectFilter<any> {
        return isGroupSelectFilter(value);
    }
}
